import type { NavigationCategory, NavigationItem } from '../types/navigation.types';

// ==================== CODE MAPPINGS ====================

export const CODE_TO_NAME_MAP: Record<string, string> = {
  MQ: 'Manual da Qualidade',
  PR: 'Procedimento',
  DO: 'Dados',
  IT: 'Instrução de Trabalho',
  DA: 'Dados',
  MP: 'Manual de Procedimentos',
  FM: 'Formulário',
  NM: 'Norma',
  PL: 'Política',
  PN: 'Plano',
  RP: 'Relatório',
};

export const QUALITY_RECORDS_ROOT_CODE = 'RQ';

export const STORAGE_KEY = 'navigation_state';

export const MODULES: NavigationItem[] = [];

export const DOCUMENT_TYPE_CATEGORY_ID = 'document';

export const createNavigationCategories = (
  documentTypes: NavigationItem[],
  modules: NavigationItem[] = []
): NavigationCategory[] => {
  const categories = [
    {
      id: DOCUMENT_TYPE_CATEGORY_ID,
      name: 'Tipo de Documento',
      type: 'document' as const,
      items: documentTypes,
    },
    {
      id: 'module',
      name: 'Módulo',
      type: 'module' as const,
      items: modules,
    },
  ];

  return categories;
};
